import { render } from "./DefaultBackend.vue?vue&type=template&id=d409d4da"
import script from "./DefaultBackend.vue?vue&type=script&lang=js"
export * from "./DefaultBackend.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__